import apiClient from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_ORDER_URL

export const _get = async (productId, queryParam) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
  }

  const response = await apiClient({
    baseURL,
    method: 'GET',
    url: `/product/${productId}/uom`,
    params: params,
  })

  return response?.data
}

export const get = (productId) => async (queryParam) => await _get(productId, queryParam)
